<div
    class="tags a-fx a-fx-wrap a-fx-start-center"
    (click)="input.focus()"
    [class.focused]="document.activeElement === input"
>
    <div *ngFor="let tag of tags || []" class="tag a-fx a-fx-start-center">
        <nz-tag nzMode="closeable" (nzOnClose)="onTagClose($event, tag)">{{ tag }}</nz-tag>
    </div>

    <input
        [placeholder]="tags?.length ? '' : placeholder"
        [(ngModel)]="currentValue"
        (keydown.enter)="onEnter($event)"
        (paste)="onPaste($event)"
        (blur)="assertAddTag()"
        #input
    />
</div>
